var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 16,
    width: 16,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.75 8.494c0-.616-.051-1.066-.162-1.533H8.403v2.783h4.218c-.085.692-.545 1.734-1.565 2.434l-.014.093 2.271 1.725.158.015c1.445-1.308 2.279-3.233 2.279-5.517z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.402 15.828c2.066 0 3.8-.667 5.068-1.817l-2.415-1.833c-.647.442-1.514.75-2.653.75a4.598 4.598 0 01-4.354-3.117l-.09.008-2.362 1.791-.031.085c1.258 2.45 3.843 4.133 6.837 4.133z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.049 9.811a4.534 4.534 0 01-.255-1.483c0-.517.093-1.017.246-1.483l-.004-.1-2.392-1.82-.078.036C1.047 5.978.75 7.12.75 8.328s.297 2.35.816 3.367z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.402 3.728c1.437 0 2.406.608 2.959 1.117l2.16-2.067C12.194 1.57 10.468.828 8.4.828c-2.993 0-5.578 1.683-6.836 4.133l2.474 1.884a4.618 4.618 0 014.363-3.117z"
  }))));
}
export default SvgGoogle;